module.exports = __webpack_public_path__ + "img/github.c14cfbaf.png";